module.exports = __webpack_public_path__ + "assets/img/NET.3ca7f3ea.jpg";